
import { defineComponent, onMounted, ref } from 'vue';
import NavTop from "@/components/NavTop.vue"

export default defineComponent({
    components:{
        NavTop
    },
    setup(){
        console.log(1)
        const height = ref(0);
        onMounted(() => {
            height.value = document.documentElement.clientHeight;
        })
        window.onresize=function(){  
            height.value = document.documentElement.clientHeight;
        }
        return {
            height
        }
    }
})
